export type ReportSectionId =
  | 'executive_summary'
  | 'current_challenge'
  | 'user_personas'
  | 'user_stories'
  | 'requirements_constraints'
  | 'demonstrator_prototype'
  | 'appendix';

export interface SectionReadiness {
  id: ReportSectionId;
  score: number; // 0-100
  confidence: 'low' | 'medium' | 'high';
  missingData: string[];
}

export interface ReportSection {
  id: ReportSectionId;
  title: string;
  readiness: SectionReadiness | null;
  content: string | null; // markdown
  generatedAt: string | null;
  editedAt: string | null;
  isGenerating: boolean;
}

export interface ReportTemplate {
  templateId: string;
  name: string;
  s3Key: string;
  uploadedAt: string;
}

export const REPORT_SECTIONS: { id: ReportSectionId; title: string; description: string }[] = [
  { id: 'executive_summary', title: 'Executive Summary', description: 'High-level overview of the engagement and key outcomes' },
  { id: 'current_challenge', title: 'Current Challenge', description: 'Problem context and stakeholder pain points' },
  { id: 'user_personas', title: 'User Personas', description: 'Key user profiles and their characteristics' },
  { id: 'user_stories', title: 'User Stories', description: 'User stories with acceptance criteria' },
  { id: 'requirements_constraints', title: 'Key Requirements & Constraints', description: 'Extracted requirements and governance constraints' },
  { id: 'demonstrator_prototype', title: 'The Demonstrator / Prototype', description: 'Build artifacts, architecture decisions, and technology choices' },
  { id: 'appendix', title: 'Appendix', description: 'Mockups, whiteboards, and per-avatar contribution summaries' },
];
